import { isPlatformBrowser } from '@angular/common';
import { ElementRef, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TimeUtils } from '@freelancer/time-utils';
import { UserAgent } from '@freelancer/user-agent';

export interface FocusOptions {
  selector?: string;
}

@Injectable({
  providedIn: 'root',
})
export class Focus {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private userAgent: UserAgent,
    private timeUtils: TimeUtils,
  ) {}

  /**
   * Focuses the native element of a given ElementRef,
   * or the first child that matches a selector if specified.
   */
  focusElement(ref: ElementRef<HTMLElement>, { selector }: FocusOptions = {}) {
    if (
      // don't focus on the server because it doesn't make sense
      isPlatformBrowser(this.platformId) &&
      // don't focus on mobile browsers because the keybaord UX is bad
      !this.userAgent.isMobileDevice()
    ) {
      const elementToFocus = selector
        ? ref.nativeElement.querySelector<HTMLElement>(selector)
        : ref.nativeElement;

      if (elementToFocus) {
        this.timeUtils.setTimeout(() => {
          elementToFocus.focus();
        });
      }
    }
  }
}
